import React from 'react';

const petServiceProviders = [
  {
    name: "Dr. Abhishek",
    role: "Veterinarian",
    qualifications: "B.V.Sc & A.H",
    reviews: "3000+ Reviews",
    experience: "14+ years of professional experience",
    repeat_pet_parents: "4000+",
    feedback: "An Awesome experience for my cat's prolonged health issue! Thank you Dr. Abhishek for giving deep insight on the problem",
    image: "//dm6g3jbka53hp.cloudfront.net/static-images/dr-abhishek-04042020.jpg"
  },
  {
    name: "MD. Wasim",
    role: "Pet Groomer",
    reviews: "2000+ Reviews",
    experience: "6+ years of professional experience",
    repeat_pet_parents: "6000+",
    feedback: "I absolutely loved the way Waseem was with my lad, there wasn't even a hint of discomfort. They were really good at their jobs, friendly and professional. Clean job, and 10 on 10 I will again call you guys when I'll need. Thank you!",
    image: "//dm6g3jbka53hp.cloudfront.net/static-images/wassem-groomer-thepetnet-05012019.jpg"
  },
  {
    name: "Manjunath B.H",
    role: "Dog Trainer",
    reviews: "1500+ Reviews",
    experience: "8+ years of professional experience",
    repeat_pet_parents: "2000+",
    feedback: "Hi.... This was my first time and I am happy with the training service provided by Manjunath... I have been previously dealing with other trainers from trainmydog and wasn't happy ... Thank you ThePetNest❤️❤️❤️",
    image: "//dm6g3jbka53hp.cloudfront.net/static-images/naveen-groomer-thepetnet-05012019.jpg"
  }
];

const Drpart = () => {
  return (
    <div>
      <div className="bg-slate-50">
        <div className="text-4xl font-bold text-center md:mt-16">
          <p className="pt-12">Meet Pet Care Service Providers at Adopt a Pet</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6 w-[90%] mx-auto">
          {petServiceProviders.map((provider, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 hover:shadow-xl transition-shadow md:my-12"
            >
              <img src={provider.image} alt="" className="h-[250px] sm:h-[300px] md:h-[350px] w-full object-cover rounded-t-lg" />
              <h2 className="text-xl font-semibold text-gray-800 mt-4">{provider.name}</h2>
              <p className="text-sm text-gray-500">{provider.role}</p>
              <p className="mt-2 text-gray-700">{provider.qualifications}</p>
              <p className="mt-2 text-gray-600">
                <strong>Reviews:</strong> {provider.reviews}
              </p>
              <p className="mt-1 text-gray-600">
                <strong>Experience:</strong> {provider.experience}
              </p>
              <p className="mt-1 text-gray-600">
                <strong>Repeat Pet Parents:</strong> {provider.repeat_pet_parents}
              </p>
              <blockquote className="mt-4 text-gray-800 italic border-l-4 border-indigo-500 pl-4">
                "{provider.feedback}"
              </blockquote>
            </div>
          ))}
        </div>
      </div>

      <div className="text-center mt-16">
        <img src="//dm6g3jbka53hp.cloudfront.net/static-images/homepage__partners-section__hooked-icon.svg" alt="" className="mx-auto" />
        <p className="text-4xl mt-8 font-extrabold">Ready to book your next pet service with Adopt a Pet?</p>
        <button className="bg-orange-500 w-[80%] sm:w-[400px] h-[60px] text-white font-semibold text-2xl rounded-xl mt-8">Book a Pet Service</button>
        <img src="//dm6g3jbka53hp.cloudfront.net/static-images/dog-on-phone-30032020.png" alt="" className="mx-auto mt-12 h-[250px] sm:h-[300px]" />
        <img src="//dm6g3jbka53hp.cloudfront.net/static-images/cat-vet-30032020.png" alt="" className="md:ml-[400px] mt-[-120px] sm:mt-[-200px] h-[180px] sm:h-[200px]" />
      </div>
    </div>
  );
};

export default Drpart;
